import clsx from "clsx";

const FilesContainer = ({ children, ...rest }) => {
  return (
    <div
      {...rest}
      className={clsx(
        "max-w-[75%] lg:max-w-[55%] ml-auto w-fit py-0 px-0 rounded-xl leading-6 font-notosans  whitespace-pre-wrap",
        rest.className
      )}
    >
      {children}
    </div>
  );
};

export default FilesContainer;
